document.documentElement.classList.remove('no-js');

class BrainFartTheme {
  constructor() {
    this.bindMenu();
    this.bindVariantSelectors();
    this.bindSort();
  }

  bindMenu() {
    const open = document.querySelector('[data-menu-open]');
    const close = document.querySelector('[data-menu-close]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!open || !close || !menu) return;

    const setOpen = (value) => {
      menu.classList.toggle('is-open', value);
      document.body.classList.toggle('menu-open', value);
      open.setAttribute('aria-expanded', String(value));
      menu.setAttribute('aria-hidden', String(!value));
      if (value) close.focus(); else open.focus();
    };

    open.addEventListener('click', () => setOpen(true));
    close.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.classList.contains('is-open')) setOpen(false);
    });
  }

  bindVariantSelectors() {
    document.querySelectorAll('[data-product-form]').forEach((form) => {
      const variantDataNode = form.querySelector('[data-variant-json]');
      const idInput = form.querySelector('[name="id"]');
      const priceNode = document.querySelector(`[data-price-for="${form.id}"]`);
      const button = form.querySelector('[type="submit"]');
      const optionGroups = [...form.querySelectorAll('[data-option-position]')];
      if (!variantDataNode || !idInput) return;

      let variants = [];
      try { variants = JSON.parse(variantDataNode.textContent); } catch (error) { return; }

      const getSelectedValues = () => optionGroups.map((group) => {
        const checked = group.querySelector('input:checked');
        const select = group.querySelector('select');
        return checked ? checked.value : (select ? select.value : null);
      });

      const updatePrice = (variant) => {
        if (!priceNode || !variant) return;
        const priceEl = priceNode.querySelector('.price');
        const currentEl = priceNode.querySelector('[data-current-price]');
        const compareEl = priceNode.querySelector('[data-compare-price]');
        const onSale = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
        if (priceEl) priceEl.classList.toggle('price--sale', onSale);
        if (currentEl && variant.price_formatted) currentEl.textContent = variant.price_formatted;
        if (compareEl) {
          if (onSale && variant.compare_at_price_formatted) compareEl.textContent = variant.compare_at_price_formatted;
          compareEl.hidden = !onSale;
        }
      };

      // Grey out / disable option values that don't lead to any purchasable
      // variant given what's currently selected in the other option groups.
      const updateAvailability = (selectedValues) => {
        optionGroups.forEach((group, position) => {
          group.querySelectorAll('input[type="radio"]').forEach((input) => {
            const hypothetical = selectedValues.slice();
            hypothetical[position] = input.value;
            const match = variants.find((candidate) =>
              hypothetical.every((value, index) => value === null || candidate.options[index] === value)
            );
            input.disabled = !(match && match.available);
          });
        });
      };

      const update = () => {
        const selectedValues = getSelectedValues();
        updateAvailability(selectedValues);

        const variant = variants.find((candidate) =>
          selectedValues.every((value, index) => candidate.options[index] === value)
        );

        if (!variant) {
          button.disabled = true;
          button.textContent = button.dataset.unavailableText || 'Unavailable';
          return;
        }

        idInput.value = variant.id;
        button.disabled = !variant.available;
        button.textContent = variant.available
          ? (button.dataset.addText || 'Add to cart')
          : (button.dataset.soldText || 'Sold out');

        updatePrice(variant);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      form.addEventListener('change', update);
      update();
    });
  }

  bindSort() {
    document.querySelectorAll('[data-sort-by]').forEach((select) => {
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.assign(url.toString());
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new BrainFartTheme());
